var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOsNameIcon = function SvgOsNameIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#AEAEB2",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45 15h-1.2c-.663 0-1.2-.537-1.2-1.2v-3.6c0-.663.537-1.2 1.2-1.2h1.2c.663 0 1.2.537 1.2 1.2v3.6c1.77636e-15.663-.537 1.2-1.2 1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.95 10.2v0c0-.663-.537-1.2-1.2-1.2h-1.2c-.663 0-1.2.537-1.2 1.2v.335c0 .517.331.975.821 1.138l1.959.653c.49.163.821.622.821 1.138v.336c0 .663-.537 1.2-1.2 1.2h-1.2c-.663 0-1.2-.537-1.2-1.2v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21h-4c-3.866 0-7-3.134-7-7v-4c0-3.866 3.134-7 7-7h4c3.866 0 7 3.134 7 7v4c0 3.866-3.134 7-7 7Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24h-24Z"
  })));
};
export { SvgOsNameIcon as ReactComponent };
export default __webpack_public_path__ + "os-name-icon.svg";